import 'angular';
import '../approvalCommentsPanel/approvalCommentsPanel';
import '../approvalFilesPanel/approvalFilesPanel';
import '../approvalPeoplePanel/approvalPeoplePanel';
import './approval_view_right_panel.html'

angular.module('GorillaBoy.Approvals')
.directive('approvalsRightPanel', () => {
    return {
        restrict: 'E',
        templateUrl: './approvals/approvalView/approvalViewRightPanel/approval_view_right_panel.html',
    };
});